import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { Link } from "react-router-dom";
var StepsSection = function StepsSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var items = [{
    image: CDN_LINK + "/assets/images/compare/step1.png",
    smallText: tShort("compare/step1", {
      ns: "web_common"
    }),
    boldText: tShort("compare/step1_text", {
      ns: "web_common"
    })
  }, {
    image: CDN_LINK + "/assets/images/compare/step2.png",
    smallText: tShort("compare/step2", {
      ns: "web_common"
    }),
    boldText: tShort("compare/step2_text", {
      ns: "web_common"
    })
  }, {
    image: CDN_LINK + "/assets/images/compare/step3.png",
    smallText: tShort("compare/step3", {
      ns: "web_common"
    }),
    boldText: tShort("compare/step3_text", {
      ns: "web_common"
    })
  }, {
    image: CDN_LINK + "/assets/images/compare/step4.png",
    smallText: tShort("compare/step4", {
      ns: "web_common"
    }),
    boldText: tShort("compare/step4_text", {
      ns: "web_common"
    })
  }, {
    image: CDN_LINK + "/assets/images/compare/step5.png",
    smallText: tShort("compare/step5", {
      ns: "web_common"
    }),
    boldText: tShort("compare/step5_text", {
      ns: "web_common"
    })
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "pb-16 lg:pb-26 px-4 lg:px-20 bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center mb-9"
  }, /*#__PURE__*/React.createElement("p", {
    className: "tracking-wide text-sm mb-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#6C7A8D]"
  }, tShort("compare/steps_breadcrumb_home", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-[#6C7A8D]"
  }, " / "), /*#__PURE__*/React.createElement("span", {
    className: "text-primary"
  }, tShort("compare/steps_breadcrumb_compare_car", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("h2", {
    className: "text-2xl font-bold text-primary"
  }, tShort("compare/how_start", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12"
  }, items.slice(0, 3).map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "flex flex-col items-center text-center"
    }, /*#__PURE__*/React.createElement("img", {
      src: item.image,
      alt: item.boldText,
      className: "w-full max-w-xs h-48 object-cover mb-6 border rounded-lg shadow bg-[#F4F9FE]",
      height: "192",
      width: "320",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-sm font-bold text-[#697A8F]"
    }, item.smallText), /*#__PURE__*/React.createElement("h3", {
      className: "text-xl font-bold mt-1 text-primary"
    }, item.boldText));
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto lg:mb-10"
  }, items.slice(3).map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "flex flex-col items-center text-center"
    }, /*#__PURE__*/React.createElement("img", {
      src: item.image,
      alt: item.boldText,
      className: "w-full max-w-xs h-48 object-cover mb-6 border rounded-lg shadow bg-[#F4F9FE]",
      height: "192",
      width: "320",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-sm font-bold text-[#697A8F]"
    }, item.smallText), /*#__PURE__*/React.createElement("h3", {
      className: "text-xl font-bold mt-1 text-primary"
    }, item.boldText));
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center hidden md:block"
  }, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/autos"),
    className: "bg-primary text-white px-6 py-3 rounded font-bold hover:bg-primary-110 transition border-none outline-none cursor-pointer min-w-[242px] inline-block text-center"
  }, tShort("compare/hero_cta", {
    ns: "web_common"
  }))));
};
export default StepsSection;